import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { GroupDescriptor, State, process, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent, FilterService } from '@progress/kendo-angular-grid';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { FlowManagementService, flatten } from '../services/flow-management.service';
import { PowerBaseComponent } from '../powerapps/powerbase.component';
import { FlowEventService } from '../services/flow-event.service';
import { PaymentService } from '../services/payment.service';
import { Flow } from '../obj/Flow';
import { BehaviorSubject } from 'rxjs';
import { FlowRun } from '../obj/FlowRun';
import { UserItem } from '../services/storage-types';
import { getTriggerIconUrl } from './trigger-icon.util';

@Directive()
export class FlowBaseComponent extends PowerBaseComponent implements OnInit {

  private triggerIconSafeCache = new Map<string, { rawUrl: string; safeUrl: SafeUrl }>();

  constructor(
    protected apiService: FlowManagementService,
    protected flowEventService: FlowEventService,
    protected paymentService: PaymentService,
    protected sanitizer: DomSanitizer,
    protected router: Router,
  ) {
    super(apiService, sanitizer);
  }

  public flows$: BehaviorSubject<Flow[]> = new BehaviorSubject([]);
  public runs$: BehaviorSubject<FlowRun[]> = new BehaviorSubject([]);
  public users$: BehaviorSubject<UserItem[]> = new BehaviorSubject([]);
  public selection: string[] = [];

  public async doEditJSON(flow: Flow = null) {

    var status = await this.paymentService.checkSubscription();
    if (!status) return;

    // Navigate to /json for the first selected flow. Multi-select used to
    // open one tab per flow; with route navigation only one URL can be the
    // current view, so we route to the first and let the user navigate
    // back for the rest. Inheriting components (e.g. flow-admins) pass
    // `?admin=true` automatically — see the (this as any).fieldIsAdmin
    // peek so we don't have to thread admin through every override.
    const [first] = this.getSelectedFlows(flow);
    if (!first?.environment || !first?.flowName) return;
    const isAdmin = !!(this as any).fieldIsAdmin;
    this.router.navigate(
      ['/flows', first.environment, first.flowName, 'json'],
      isAdmin ? { queryParams: { admin: 'true' } } : {}
    );
  }
  protected getSelectedFlows(flow:Flow = null): Flow[] {
    let flows = [];
    if (flow) {
        flows = this.flows$.value.filter(f => {
            return (flow && f.flowName == flow.flowName);
        });

        // if selection doesn't include current right-click then
        // change selection to current
        if (this.selection?.length > 0 && this.selection.indexOf(flow.flowName) == -1) {
          this.selection = [flow.flowName];
        }
    }
    if (this.selection?.length > 0) {
        flows = this.flows$.value.filter(f => {
            return this.selection.indexOf(f.flowName) != -1;
        });
    }
    return flows;
  }

  public getTriggerIcon(flow: Flow) {
    const url = getTriggerIconUrl(flow);

    const key = flow?.flowName || (flow as any)?.name || JSON.stringify(flow?.triggers || []);
    const cached = this.triggerIconSafeCache.get(key);

    if (cached && cached.rawUrl === url) {
      return cached.safeUrl;
    }

    const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
    this.triggerIconSafeCache.set(key, { rawUrl: url, safeUrl });
    return safeUrl;
  }



}
